<template>
	<v-flex>
		<div v-if="textarea">
			<v-textarea
				:prepend-icon="prependIcon"
				browser-autocomplete="off"
				:disabled="disabled"
				:label="label"
				:error-messages="errorMessages"
				:rules="rules"
				:value=editedValue
				:placeholder="placeholder"
				:rows="rows"
				:outline="outline"
				:auto-grow="autoGrow"
				:maxlength="maxLength"
				data-vv-scope="scope1"
				validate-on-blur
				@input="val => save(val)"
				@change="val => save(val, true)"
				@blur="$emit('blur')"
				aria-label="label for text"
				class="no-print"
			></v-textarea>
			<div class="div-for-print"><p><strong style="font-size: 12px">{{label}}</strong></p>{{editedValue}}</div>
		</div>

		<div v-else>
			<v-text-field
				:prepend-icon="prependIcon"
				browser-autocomplete="off"
				:style="red ? 'background-color: #ff8f8d' : (green ? 'background-color: #5Ecf50' : '')"
				:disabled="disabled"
				:label=label
				:error-messages="errorMessages"
				:rules="rules"
				:value=editedValue
				:placeholder="placeholder"
				data-vv-scope="scope1"
				:maxlength="maxLength"
				validate-on-blur
				@input="val => save(val)"
				@change="val => save(val, true)"
				@blur="$emit('blur')"
				aria-label="label for text"
			></v-text-field>
		</div>
	</v-flex>
</template>

<script>
	export default {
		name: "egrantyTextInputField",

		data() {
			return {
				editedValue: "",
				errorMessages: "",
			};
		},

		computed: {
			rules() {
				if (this.required) {
					return [requiredRule, ...this.validationRules];
				} else {
					return [...this.validationRules];
				}
			},
		},

		methods: {
			save(val, change) {
				this.editedValue = val;
				if (change !== true) {
					this.$emit("input", val);
				} else {
					this.$emit("change", val);
				}
				this.$emit("update:valid", this.validate(val) === true);
			},

			validate(val) {
				let valid = true;
				this.rules.forEach(function (rule) {
					valid = valid && rule(val);
				});
			},
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					this.editedValue = val;
					this.$emit("update:valid", this.validate(val) === true);
				},
			},
		},


		props: {
			red: Boolean,
			green: Boolean,
			disabled: {type: Boolean, default: false},
			value: String,
			label: String,
			valid: Boolean,
			prependIcon: {type: String, default:""},
			placeholder: {type: String, default: ""},
			textarea: {type: Boolean, default: false},
			required: {type: Boolean, default: true},
			rows: {type: String, default: "3"},
			validationRules: {type: Array, default: () => []},
			outline: {type: Boolean, default: true},
			autoGrow: {type: Boolean, default: false},
			maxLength: {type: Number, default: 20000}
		},
	};

	function requiredRule(value) {
		return !value ? "To pole jest wymagane." : true;
	}

</script>

<style scoped>
	.item {
		max-width: 300px;
		margin: 30px;
	}
</style>
